import React from "react";

const ArrowIcon = ({ color = "#000" }) => (
  <svg
    className="arrow-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill={color}
        d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
      />
    </g>
  </svg>
);

export default ArrowIcon;
